module.exports = __webpack_public_path__ + "img/06-mobile.81205dd0.jpg";